import {api} from '@/libs/baseApi.client';

export const addFavoritesOptions = async (eeId: number) => {
  const response = await api.post(`/ee/favorites/add`, {
    eeId,
  });
  return response.data;
};
